import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import Logo from "../../assets/svg/logo.inline.svg";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const PostTile = ({ post, ...props }) => {
  if (!post) return;
  const imageData = getImage(post.featuredImage?.node?.localFile);
  const urlToUse = post.uri.endsWith("/") ? post.uri : post.uri + "/";
  return (
    <li className={"post-tile"} {...props}>
      <Link to={urlToUse}>
        <div className="img-wrap">
          {imageData ?
            <GatsbyImage alt={post.featuredImage.node.altText} image={imageData}/> :
            <div className={"placeholder"}>
              <Logo/>
            </div>
          }
          <div className="button-wrap">
            <span className="gradient-button">อ่านต่อ</span>
          </div>
        </div>

        <div className="post-title">{post.title}</div>
        <div className="post-date">{post.date}</div>
        <div className="post-excerpt" dangerouslySetInnerHTML={{ __html: post.excerpt }}/>
      </Link>
    </li>
  );
};

export default PostTile;

PostTile.propTypes = {
  index: PropTypes.number,
  post: PropTypes.object,
};
